import { Component } from "react"
import PropTypes from "prop-types"
import { CloudUpload } from "@mui/icons-material"
import Upload from "components/upload"
import UploadScanPreview from "modules/upload-scan-preview"
import UploadHeader from "components/upload/components/upload-header"
import UploadContainer from "components/upload/components/upload-container"
import UploadStep from "components/upload/components/upload-step"
import Stepper from "components/stepper/"
import ErrorPage from "components/404"

export default class WatchlistPositions extends Component {
  static propTypes = {
    navigate: PropTypes.func.isRequired,
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
    watchlistDetails: PropTypes.object.isRequired,
    files: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    uploadConfig: PropTypes.object.isRequired,
    uploadOption: PropTypes.string,
    uploadedFiles: PropTypes.array.isRequired,
    addFiles: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    uploadDateTime: PropTypes.object,
    scanResult: PropTypes.object,
    resetScan: PropTypes.func.isRequired,
    scanFiles: PropTypes.func.isRequired,
    confirmUpload: PropTypes.func.isRequired,
    changeUploadOption: PropTypes.func.isRequired,
    setModel: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    resetUpload: PropTypes.func.isRequired,
    account: PropTypes.string.isRequired,
    models: PropTypes.array.isRequired,
  }

  static getHeaderConfig({ openDialog, navigate, account, resetUpload }) {
    return {
      icon: CloudUpload,
      title: "Manage Securities",
      key: "watchlist-upload",
      actions: {
        home: () => openDialog({
          title: "Would you like to cancel this upload",
          contentText: "Canceling will clear all options and delete any data provided during this upload.",
          cancelText: "Return To Upload",
          buttons: [{
            text: "Cancel Upload",
            type: "primary",
            action: () => {
              navigate(`/${account}/home/resources`, { replace: true })
              resetUpload()
            },
          }],
        }),
      },
    }
  }

  onSubmit = () => {
    const { scanFiles, files, uploadOption, activeStep, confirmUpload } = this.props

    switch (activeStep) {
      case 0:
        scanFiles(files)
        break
      case 1:
        confirmUpload(uploadOption)
        break
    }
  }

  setModel = (ev) => {
    const { setModel } = this.props
    setModel(ev.target.value)
  }

  render() {
    const {
      navigate,
      activeStep,
      steps,
      watchlistDetails,
      files,
      params,
      uploadConfig,
      uploadOption,
      uploadedFiles,
      addFiles,
      removeFile,
      addNotification,
      uploadDateTime,
      scanResult,
      resetScan,
      changeUploadOption,
      models,
    } = this.props

    if (watchlistDetails === null) {
      return <ErrorPage layoutDeactivated />
    }

    let currentStep
    if (!params.step) {
      currentStep = <UploadStep
        addFiles={addFiles}
        files={files}
        removeFile={removeFile}
        addNotification={addNotification}
        uploadConfig={uploadConfig}
        type="watchlist"
        docLink="https://support.ompnt.com/en/articles/78542-uploads-in-common-position-format"
      />
    } else if (params.step === "preview") {
      currentStep = <UploadScanPreview
        showOverrideOptions={watchlistDetails.count > 0}
        target={watchlistDetails}
        uploadDateTime={uploadDateTime}
        scanResult={scanResult}
        type="watchlist"
        resetScan={resetScan}
        uploadStep={steps[0]}
        changeUploadOption={changeUploadOption}
        uploadOption={uploadOption}
      />
    }

    return <Upload>
      <UploadHeader
        type="watchlist"
        target={watchlistDetails}
        models={models}
        setModel={this.setModel}
        editableModel={activeStep === 0}
      />
      <UploadContainer>
        <Stepper
          goBack={() => { navigate(-1) }}
          steps={steps}
          activeStep={activeStep}
          disableVariables={{ files, uploadOption, uploadedFiles, availableFrom: watchlistDetails.availableFrom }}
          onSubmit={this.onSubmit}
          stepComponent={currentStep}
        />
      </UploadContainer>
    </Upload>
  }
}
